module.exports = __webpack_public_path__ + "img/m3.f256ed13.png";